import * as types from '../actions/appointments/types';


const INITIAL_STATE = {
  defaultEmailRecipient: '',
  filterItems: [],
  labels: [],
  past: [],
  slots: [],
  possibleMessageRecipients: [],
  upcoming: [],
};

export default function appointmentsReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.GET_ALL_SLOTS:

      return {
        ...state,
        slots: action.payload,
      };

    case types.GET_APPOINTMENT_MESSAGE_RECIPIENTS:

      return {
        ...state,
        possibleMessageRecipients: action.payload,
      };

    case types.GET_DEFAULT_EMAIL_RECIPIENT:

      return {
        ...state,
        defaultEmailRecipient: action.payload,
      };

    case types.GET_FILTER:

      return {
        ...state,
        filterItems: action.payload,
      };

    case types.GET_APPOINTMENT_TIME_RANGE:

      return {
        ...state,
        appointmentTimeRange: action.payload,
      };

    case types.GET_FILTER_LABELS:

      return {
        ...state,
        labels: action.payload,
      };

    case types.GET_PAST_APPOINTMENTS:

      return {
        ...state,
        past: action.payload,
      };

    case types.GET_UPCOMING_APPOINTMENTS:

      return {
        ...state,
        upcoming: action.payload,
      };

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/appointmentsReducer.js